import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchItemCategoryList = ({commit}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/itemCategory/index.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setItemCategoryList', res.data.response)         
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchAllCategoryList = ({commit}) => {
    commit('toggleLoadingState', true)
    console.log("Here")
    axios.get('/itemCategory/allCategoryList.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setItemCategoryList', res.data.response)         
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchAllItemCategoryList = ({commit}) => {

    axios.get('/itemCategory/allType.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setAllItemCategoryList', res.data.response)         
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchItemSubCategoryList = ({commit}, payload) => {

    axios.post('/itemCategory/allSubCategory.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setItemCategoryList', res.data.response)         
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchItemSubCategoryList_Fabric = ({commit}, payload) => {

    axios.post('/itemCategory/allSubCategory.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setItemCategoryList_Fabric', res.data.response)         
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchItemCategoryData = ({commit}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/itemCategory/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            if(payload.copy) {
                res.data.response.id = 0
                commit('displaySuccessNotification', {message: 'Data copied!!!'});                
            }
            
            commit('setItemCategoryData', {response: res.data.response, copy: payload.copy})   
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetItemCategoryData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitItemCategoryData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/itemCategory/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            dispatch('fetchItemCategoryData', {id: payload.id})
            if(payload.id === 0) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteItemCategoryData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/itemCategory/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchItemCategoryList', {type: payload.type})
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/itemCategory/actions.js